import { useEffect, useState } from "react";
import { TermsOfUseListScreen } from "../../screen/TermsOfUseListScreen";
import { useScope } from "../SelectProjectCompanyContainer";
import Send from "../../core/communication";
import { customToast } from "../../components/Toast";
import { useSelector } from "react-redux";

// formId = '6dc33e85-9dc4-4dc1-8caa-35ce36cc63c9'
const loadData = async (setData, projectId, scopeType) => {
  try {
    const response = await Send.get(`/assistance-request/project/${projectId}`, `scopeType=${scopeType}`);

    setData(response);
  } catch(error) {
    console.log("Erro ao buscar dados", error);
    customToast("Erro ao buscar dados", 'error');
    setData([]);
  }
}

const TermsOfUseListContainer = () => {
  const { scope, scopeType } = useScope();
  const isUserAdmin = useSelector(state => state.app?.isUserAdmin);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(null);
  const [modalActions, setModalActions] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    if(scope?.id) {
      setLoading(true);
      loadData(setData, scope?.id, scopeType)
      .then(res => setLoading(false));
    }
  }, [scope]);

  const handleFilter = (value) => {
    setFilter(value);
  }

  const applyFilter = (newData) => {
    if(filter && filter !== '') {
      return newData.filter(item =>
        item?.PRODUTOR.includes(filter) ||
        item?.PRODUTOR_EMAIL.includes(filter)
      );
    }

    return newData;
  }

  const handleOpenActionsModal = () => {
    setModalActions(true);
  }

  const handleCloseActionsModal = () => {
    setModalActions(false);
  }

  const handleSelectedUsers = (value) => {
    let newSelectedUser = value.map((item, index) => {

      if(value.slice(0, index).find(row => row?.PRODUTOR_EMAIL === item?.PRODUTOR_EMAIL)) {
        return null;
      }

      return {
        id: item.PRODUTOR_ID,
        name: item.PRODUTOR,
        email: item.PRODUTOR_EMAIL,
        project: item?.project,
        projectId: item?.projectId
      };
    }).filter(user => user);

    setSelectedRows(value)
    setSelectedUsers(newSelectedUser ?? []);
  }

  return <TermsOfUseListScreen {...{
    loading,
    data: applyFilter(data),
    handleFilter,
    modalActions,
    handleOpenActionsModal,
    handleCloseActionsModal,
    selectedUsers,
    handleSelectedUsers,
    selectedRows,
    isUserAdmin,
  }} />
}

export default TermsOfUseListContainer;